import { Button, Input, message } from "antd";
import { MobileOutlined } from "@ant-design/icons";
import { useCallback, useRef, useState } from "react";
import { loginApi } from "@/apis";
import { useUserInfoDispath } from "@/model";
import { useNavigate } from "react-router";
import { Encrypt } from "@/utils/crypto";
import Storage from "@/utils/store";
import { env } from "@/utils/env";
// 样式写在调用处

const { Search } = Input;

const Code = () => {
  const countRef = useRef(60);
  const dispatch = useUserInfoDispath();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [accontInfo, setAccontInfo] =
    useState<ByUserNameOrPhoneUserInfoList[]>();

  const handleCode = async () => {
    if (count !== 0) return;
    if (!phone) {
      message.error("手机号码不能为空");
      return;
    }
    try {
      const infoRes = await loginApi.getFindByUserNameOrPhone({
        userAccountOrPhone: phone,
      });
      if (!infoRes || infoRes.length === 0) {
        message.error("用户不存在，请检查手机号码是否有效");
        setAccontInfo(undefined);
        return;
      }
      setAccontInfo(infoRes);

      const codeRes = await loginApi.sendPhoneLoginVerificationCode(phone);
      message.success("验证码已发送");
      countRef.current = 59;
      setCount(countRef.current);
      const timer = setInterval(() => {
        if (countRef.current <= 0) {
          setCount(0);
          countRef.current = 60;
          clearInterval(timer);
        } else {
          countRef.current--;
          setCount(countRef.current);
        }
      }, 1000);
    } catch (error: any) {
      message.error(error);
    }
  };

  const handleSubmitLgoin = () => {
    if (!phone || !code) {
      return message.error("手机号码和验证码不能为空");
    }
    if (!accontInfo || accontInfo.length === 0) {
      message.error("用户不存在，请检查手机号码是否有效");
      return;
    }
    setLoading(true);
    loginApi
      .fetchSubmitByAccount({
        smsVerificationCode: code,
        phone: Encrypt(phone),
        appType: 2,
        type: 5,
        tenantCode: "default",
      })
      .then((res) => {
        const { success, errorMsg, data } = res;
        if (!success) {
          message.error(errorMsg);
          return;
        }

        const _curUserInfo = accontInfo[0].userVoList[0];
        // 登录信息，含有jwt等
        Storage.l.set("loginInfo", data);
        // 当前客户信息
        Storage.l.set("curUserInfo", _curUserInfo);
        dispatch({
          type: "user/setIsPhoneLogin",
          data: true
        });
        dispatch({
          type: "user/setUserInfo",
          loginInfo: data,
          curUserInfo: _curUserInfo,
        });
        dispatch({
          type: "login/close",
        });
        // 移动端
        if (env.isMobile) {
          message.success("登录成功");
          navigate("/home")
        }
      })
      .catch((err) => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const forgetPass = useCallback(() => {
    dispatch({
      type: "login/close",
    });
    navigate("/forget");
  }, [dispatch, navigate]);

  return (
    <div className="code-login-wrapper">
      <p className="modal-label">登录手机号</p>
      <Input
        value={phone}
        onChange={(e: any) => {
          setPhone(e.target.value);
        }}
        size="large"
        placeholder="请输入手机号码"
        addonBefore={<MobileOutlined style={{ fontSize: "18px" }} />}
        className="modal-item"
        allowClear
      />
      <p className="modal-label">验证码</p>
      <Search
        value={code}
        placeholder="请输入验证码"
        allowClear
        enterButton={count === 0 ? "获取验证码" : `${count}s后重新获取`}
        size="large"
        onChange={(e: any) => {
          setCode(e.target.value);
        }}
        onSearch={handleCode}
        className="modal-item"
      />
      <div className="tips-wrapper">
        <span className="forget pointer" onClick={forgetPass}>
          忘记密码
        </span>
      </div>
      <Button
        type="primary"
        style={{ width: "100%" }}
        onClick={handleSubmitLgoin}
        loading={loading}
      >
        确定
      </Button>
    </div>
  );
};

export default Code;
